var React = require('react');

function CaretLeft (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M184 256v128.91c0 17.85-22.48 26.8-35.63 14.17L14.1 270.16l-.8-.8A19.41 19.41 0 0 1 8 256z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M8 256a19.39 19.39 0 0 1 5.29-13.36c.26-.28.53-.55.8-.81L148.36 112.9c13.15-12.63 35.63-3.68 35.63 14.17V256z","className":"fa-primary","key":2})]);
}

CaretLeft.defaultProps = {"viewBox":"0 0 192 512","className":"icon"};

module.exports = CaretLeft;

CaretLeft.default = CaretLeft;
